import React from "react";
import { RCCLov } from "react-common-components";
import ILovComponent from "react-common-components/dist/components/Lov/interface";

const LovBusinessGroups: React.FC<Omit<ILovComponent, "valueProperty" | "labelProperty" | "routeAPI">> = ({
	name,
	control,
	...rest
}) => (
	<RCCLov 
		name={name} 
		control={control}
		routeAPI="BusinessGroup/Lov"
		valueProperty="Efa001Id"
		labelProperty="Efa001Fantasia"
		elementsPerPage={20}
		{...rest}
	/>
);

export default LovBusinessGroups;
